module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Thunder-e9880378b50dc3a7e4ac0c9617560267.svg";